var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.itemComponent,{ref:"triggerItem",tag:"component",attrs:{"data":_vm.data,"value":_vm.data.fieldvalue,"placeholder":_vm.placeholder},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }